import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBasketShopping } from '@fortawesome/free-solid-svg-icons'

class EposNavbar extends Component {

  
  render() {
    return (

        <React.Fragment>
            <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark" className="navbar navbar-expand-sm navbar-dark bg-primary" >
            <Container>
            
            
              <div className="navIcon"><FontAwesomeIcon icon={faBasketShopping}  size = '2x' color = 'white'/></div>
              <Navbar.Brand href="#home">Zhang-Davis Supermarket</Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="/">Home</Nav.Link>
                  <Nav.Link href="/cashier">Cashier</Nav.Link>
                  <Nav.Link href="/admin">Produce Admin</Nav.Link>

                </Nav>

              </Navbar.Collapse>
            </Container>
          </Navbar>


      </React.Fragment>
    )
  }
}

export default EposNavbar;